import { GET_ACCESSORIES_BY_SLUG } from "../../operations/queries/operations/queries/get-accessories-by-slug.js";
const getAccessoriesBySlug = async ({ client, slug, locale }) => {
  const queryResult = await client.query({
    query: GET_ACCESSORIES_BY_SLUG,
    variables: { slug },
    context: { headers: { "Accept-Language": locale } }
  });
  return queryResult;
};
export {
  getAccessoriesBySlug
};
//# sourceMappingURL=getAccessoriesBySlug.js.map
